import linkifyHtml from 'linkify-html'

const LINKIFY_OPTIONS = {
  target: '_blank',
  rel: 'noopener noreferrer',
}

export default {
  bind(el) {
    el.innerHTML = linkifyHtml(el?.textContent ?? '', LINKIFY_OPTIONS)
  },

  componentUpdated(el) {
    el.innerHTML = linkifyHtml(el?.textContent ?? '', LINKIFY_OPTIONS)
  },
}
